import { CaseIcon } from '../../assets/icons/case';
import { ChartIcon } from '../../assets/icons/chart';
import { DollarIcon } from '../../assets/icons/dollar';
import { FinanceIcon } from '../../assets/icons/finance';
import { MedalIcon } from '../../assets/icons/Medal';
import { PuzzleIcon } from '../../assets/icons/Puzzle';
import { ReloadIcon } from '../../assets/icons/Reload';
import { ResizeIcon } from '../../assets/icons/Resize';

import { ChatIcon } from '../../assets/icons/Chat';
import { PeoplesIcon } from '../../assets/icons/Peoples';
import { RunIcon } from '../../assets/icons/Run';
import { InfinityIcon } from '../../assets/icons/Infinity';
import { PlantIcon } from '../../assets/icons/Plant';

import CSIPortfolio from '../../assets/images/Portfolio/portfolio-csi.png';
import SiloamPortfolio from '../../assets/images/Portfolio/portfolio-siloam.png';
import CareadyPortfolio from '../../assets/images/Portfolio/portfolio-caready.png';

import DavidHartono from '../../assets/images/Home/Testimoni/David Hartono.png';
import DavidTuerah from '../../assets/images/Home/Testimoni/David Tuerah.png';
import HerySugiarto from '../../assets/images/Home/Testimoni/Hery Sugiarto.png';
import KevinMacario from '../../assets/images/Home/Testimoni/Kevin Macario.png';

import {
  Arista_Grey,
  Power_Character_Grey,
  astra,
  IOT,
  MobileApp,
  toyota,
  WebApp,
  Automotive_Auction,
  E_commerce,
  Health_Care,
  Hello_Fit,
  MrSafety_Grey,
} from '../../assets/images/Home';
import {
  AiSolutionAuction,
  AiSolutionAuctionChild1,
  AiSolutionAuctionChild2,
  AiSolutionAuctionChild3,
  AiSolutionEcommerce,
  AiSolutionEcommerceChild1,
  AiSolutionEcommerceChild2,
  AiSolutionEcommerceChild3,
  AiSolutionHealtcare,
  AiSolutionHealtcareChild1,
  AiSolutionHealtcareChild2,
  AiSolutionHealtcareChild3,
} from '../../assets/images/solution';

const clients = [
  { name: 'Hello_Fit', image: Hello_Fit },
  { name: 'Arista_Grey', image: Arista_Grey },
  { name: 'astra', image: astra },
  { name: 'toyota', image: toyota },
  { name: 'MrSafety_Grey', image: MrSafety_Grey },
  { name: 'Power_Character_Grey', image: Power_Character_Grey },
];

const FAQList = [
  {
    question: 'Apa yang dimaksud Startup Approach?',
    answer:
      'Startup approach merupakan metodologi pengembangan produk yang bertujuan untuk mempersingkatkan siklus pengembangan produk dan dengan cepat menemukan apakah produk yang dikembangkan layak dan sesuai untuk digunakan perusahaan. Kami mengembangkan software dan strategi digital untuk perusahaan anda melalui update MVP secara berkala dan pemvalidasian produk kepada anda sesuai kebutuhan.',
  },
  {
    question: 'Apa benar tidak ada hidden fee sama sekali?',
    answer:
      'Ya Benar. Tidak ada Hidden Fee sama sekali. Fee hanya akan dikenakan apabila ada perubahan signifikan sesuai dengan kebutuhan perusahaan dan akan didiskusikan dalam proses pengembangan.',
  },
  {
    question: 'Apa betul scope dan project bisa dirubah di tengah jalan?',
    answer:
      'Ya benar. Tidak seperti Software House lain yang scope dan detail project sudah di-lock di awal perjanjian, pengembangan produk kami lebih fleksibel karena dapat dirubah sesuai dengan kebutuhan perusahaan di tengah pengembangan software.',
  },
  {
    question: 'Mengapa costnya bisa lebih murah?',
    answer:
      'Kami mengadopsi metode kerja Start-Up sehingga dapat dengan signifikan memotong biaya dan menyediakan anda jasa dengan harga yang jauh lebih murah daripada kompetitor kami.',
  },
  {
    question:
      'Bagaimana transparansi dan mekanisme kerja developer yang dipinjamkan?',
    answer:
      'Kami akan secara berkala melaporkan progres kerja dalam pengembangan website atau aplikasi kepada anda sesuai dengan timeline kerja yang sudah ditentukan.',
  },
  {
    question: 'Apakah ada garansi terhadap software yang sudah selesai dibuat?',
    answer: 'Ya',
  },
];

const projectCategory = [
  {
    name: 'Web App',
    description: `Website Based Application with Various Features & Functions.`,
    active: true,
    image: WebApp,
  },
  {
    name: 'Mobile App',
    description: `Mobile Application Development Based on Android & IOS.`,
    active: false,
    image: MobileApp,
  },
  // {
  //   name: "UI/UX Design",
  //   description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  //               Vulputate quam vel arcu fringilla arcu. Ipsum sed pellentesque
  //               ultricies magna interdum eleifend penatibus neque. Sagittis
  //               amet, lectus vel dictum in ultricies. Id dictumst risus in id
  //               placerat consectetur lectus tristique velit.`,
  //   active: false,
  // },
  // {
  //   name: "Bussiness Intelegence",
  //   description: `Support business decisions through real-time data visualization`,
  //   active: false,
  //   image: "projectImage.png",
  // },
  {
    name: 'Internet of Things',
    description: `Build an integrated system between software & hardware.`,
    active: false,
    image: IOT,
  },
  // {
  //   name: "Growth Strategy",
  //   description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  //               Vulputate quam vel arcu fringilla arcu. Ipsum sed pellentesque
  //               ultricies magna interdum eleifend penatibus neque. Sagittis
  //               amet, lectus vel dictum in ultricies. Id dictumst risus in id
  //               placerat consectetur lectus tristique velit.`,
  //   active: false,
  // },
  // {
  //   name: "Digital Marketing",
  //   description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  //               Vulputate quam vel arcu fringilla arcu. Ipsum sed pellentesque
  //               ultricies magna interdum eleifend penatibus neque. Sagittis
  //               amet, lectus vel dictum in ultricies. Id dictumst risus in id
  //               placerat consectetur lectus tristique velit.`,
  //   active: false,
  // },
  // {
  //   name: "Enterprise Resource Planning",
  //   description: `Support your main business needs with a flexible and affordable ERP system`,
  //   active: false,
  //   image: "projectImage.png",
  // },
  // {
  //   name: "Bussiness Process Engineering",
  //   description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  //               Vulputate quam vel arcu fringilla arcu. Ipsum sed pellentesque
  //               ultricies magna interdum eleifend penatibus neque. Sagittis
  //               amet, lectus vel dictum in ultricies. Id dictumst risus in id
  //               placerat consectetur lectus tristique velit.`,
  //   active: false,
  // },
];

const ourValues = [
  {
    title: 'Deep Industry Insight',
    desc: 'We recognize that every business is unique. Our AI solutions are meticulously crafted to align with your specific needs, ensuring maximum impact and value',
    icon: ChatIcon,
  },
  {
    title: 'Custom AI Solutions',
    desc: '"Using the insights gained from our discovery phase, we develop AI models that are custom-built for your business. Whether it’s predictive analytics, automation, or advanced data analysis, our solutions are designed to meet your exact needs.',
    icon: PeoplesIcon,
  },
  {
    title: 'Agile Development',
    desc: 'We leverage agile methodologies to rapidly develop, test, and refine AI solutions, ensuring quick delivery and the flexibility to adapt to evolving requirements.',
    icon: RunIcon,
  },
  {
    title: 'Continuous Optimization',
    desc: "Our commitment doesn't end at deployment. We continuously monitor and enhance our AI solutions, driving ongoing improvements to maximize return on investment.",
    icon: InfinityIcon,
  },
  {
    title: 'Collaborative Partnership',
    desc: 'We believe in close collaboration, working side by side with our clients to ensure seamless integration, smooth adoption, and lasting success.',
    icon: PeoplesIcon,
  },
  {
    title: 'Sustainable Growth',
    desc: 'We committed to long-term success. We provide ongoing support and optimization services to ensure that your AI solutions continue to deliver value as your business grows and evolves.',
    icon: PlantIcon,
  },
];

const dataTestimoni = [
  {
    name: 'David Hartono',
    from: 'CEO of Asaba Digital Innotech',
    testimoni:
      'Codr bekerja sama dengan kami untuk menciptakan produk digital melalui proses yang transparan dan iteratif.',
    picture: DavidHartono,
  },
  {
    name: 'David Tuerah',
    from: 'Manager at Auto2000',
    testimoni:
      'Codr mendukung kami dalam mengembangkan solusi digital dengan pendekatan yang terstruktur dan iteratif',
    picture: DavidTuerah,
  },
  {
    name: 'Hery Sugiarto',
    from: 'Director of Birdmobil (Bluebird Group)',
    testimoni:
      'Codr membantu kami implementasi berbagai solusi IT dengan cepat dan andal serta hasilnya memuaskan dan sesuai ekspektasi.',
    picture: HerySugiarto,
  },
  {
    name: 'Kevin Macario',
    from: 'Falinwa International',
    testimoni:
      'Codr membantu kami implementasi berbagai solusi IT dengan cepat dan andal serta hasilnya sesuai ekspektasi.',
    picture: KevinMacario,
  },
];

const dataPortfolio = [
  {
    name: 'CSI Chat',
    overview:
      'Toyota TRUST adalah layanan resmi Toyota yang menjual mobil bekas Toyota berkualitas dan bersertifikasi sehingga pelanggan dapat menikmati garansi resmi dari PT Toyota Astra Motor. Setiap mobil bekas Toyota sudah melalui proses pengecekan di 203 titik, sehingga dapat dipastikan aman dan transparan.',
    approach:
      'Sistem Toyota TRUST berbasiskan Web Application yang terintergasi dengan aplikasi inspeksi, aplikasi sales, dan aplikasi Enterprise Resource Planning (ERP). ',
    tech_stack:
      'HTML, CSS, JavaScript, react.Js, Node.Js, Express.Js, React. Native',
    result:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
    picture: CSIPortfolio,
  },
  {
    name: 'Siloam',
    overview:
      'Toyota TRUST adalah layanan resmi Toyota yang menjual mobil bekas Toyota berkualitas dan bersertifikasi sehingga pelanggan dapat menikmati garansi resmi dari PT Toyota Astra Motor. Setiap mobil bekas Toyota sudah melalui proses pengecekan di 203 titik, sehingga dapat dipastikan aman dan transparan.',
    approach:
      'Sistem Toyota TRUST berbasiskan Web Application yang terintergasi dengan aplikasi inspeksi, aplikasi sales, dan aplikasi Enterprise Resource Planning (ERP). ',
    tech_stack:
      'HTML, CSS, JavaScript, react.Js, Node.Js, Express.Js, React. Native',
    result:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
    picture: SiloamPortfolio,
  },
  {
    name: 'Caready',
    overview:
      'Toyota TRUST adalah layanan resmi Toyota yang menjual mobil bekas Toyota berkualitas dan bersertifikasi sehingga pelanggan dapat menikmati garansi resmi dari PT Toyota Astra Motor. Setiap mobil bekas Toyota sudah melalui proses pengecekan di 203 titik, sehingga dapat dipastikan aman dan transparan.',
    approach:
      'Sistem Toyota TRUST berbasiskan Web Application yang terintergasi dengan aplikasi inspeksi, aplikasi sales, dan aplikasi Enterprise Resource Planning (ERP). ',
    tech_stack:
      'HTML, CSS, JavaScript, react.Js, Node.Js, Express.Js, React. Native',
    result:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
    picture: CareadyPortfolio,
  },
  {
    name: 'CSI Chat',
    overview:
      'Toyota TRUST adalah layanan resmi Toyota yang menjual mobil bekas Toyota berkualitas dan bersertifikasi sehingga pelanggan dapat menikmati garansi resmi dari PT Toyota Astra Motor. Setiap mobil bekas Toyota sudah melalui proses pengecekan di 203 titik, sehingga dapat dipastikan aman dan transparan.',
    approach:
      'Sistem Toyota TRUST berbasiskan Web Application yang terintergasi dengan aplikasi inspeksi, aplikasi sales, dan aplikasi Enterprise Resource Planning (ERP). ',
    tech_stack:
      'HTML, CSS, JavaScript, react.Js, Node.Js, Express.Js, React. Native',
    result:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
    picture: CSIPortfolio,
  },
  {
    name: 'Siloam',
    overview:
      'Toyota TRUST adalah layanan resmi Toyota yang menjual mobil bekas Toyota berkualitas dan bersertifikasi sehingga pelanggan dapat menikmati garansi resmi dari PT Toyota Astra Motor. Setiap mobil bekas Toyota sudah melalui proses pengecekan di 203 titik, sehingga dapat dipastikan aman dan transparan.',
    approach:
      'Sistem Toyota TRUST berbasiskan Web Application yang terintergasi dengan aplikasi inspeksi, aplikasi sales, dan aplikasi Enterprise Resource Planning (ERP). ',
    tech_stack:
      'HTML, CSS, JavaScript, react.Js, Node.Js, Express.Js, React. Native',
    result:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
    picture: SiloamPortfolio,
  },
  {
    name: 'Caready',
    overview:
      'Toyota TRUST adalah layanan resmi Toyota yang menjual mobil bekas Toyota berkualitas dan bersertifikasi sehingga pelanggan dapat menikmati garansi resmi dari PT Toyota Astra Motor. Setiap mobil bekas Toyota sudah melalui proses pengecekan di 203 titik, sehingga dapat dipastikan aman dan transparan.',
    approach:
      'Sistem Toyota TRUST berbasiskan Web Application yang terintergasi dengan aplikasi inspeksi, aplikasi sales, dan aplikasi Enterprise Resource Planning (ERP). ',
    tech_stack:
      'HTML, CSS, JavaScript, react.Js, Node.Js, Express.Js, React. Native',
    result:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
    picture: CareadyPortfolio,
  },
];

const whyCODRdata = [
  {
    title: 'Tailored AI Solutions',
    desc: 'We recognize that every business is unique. Our AI solutions are meticulously crafted to align with your specific needs, ensuring maximum impact and value.',
    icon: PuzzleIcon,
  },
  {
    title: 'Proven Expertise',
    desc: 'Our team consists of industry-leading AI experts, data scientists, and engineers with a track record of successful AI implementations across various sectors, including finance, healthcare, retail, and manufacturing.',
    icon: MedalIcon,
  },
  {
    title: 'End-to-End Implementation',
    desc: 'From strategy to deployment and beyond, we provide comprehensive support throughout your AI journey, ensuring a seamless transition to AI-driven processes.',
    icon: ReloadIcon,
  },
  {
    title: 'Scalable AI Architectures',
    desc: "We build AI systems that are not only robust and efficient but also scalable. Whether you're a startup or a large enterprise, our solutions grow with your business, adapting to increasing demands and complexity.",
    icon: ResizeIcon,
  },
];

const ourSolutionsData = [
  {
    title: 'Asisten AI',
    link: 'Asisten_AI',
    desc: 'Kami siap membantu bisnis Anda menghadapi tantangan era digital. Melalui layanan konsultasi, kami merancang strategi yang tepat, mengidentifikasi peluang terbaik, dan menyusun langkah-langkah konkret yang sejalan dengan tujuan bisnis Anda, sekaligus memastikan kepatuhan pada standar industri.',
    image: E_commerce,
    banner: AiSolutionEcommerce,
    description: `
        Dalam dunia e-commerce yang terus berkembang, memberikan layanan pelanggan yang luar biasa dan personal adalah kunci untuk tetap unggul. Di CODR, kami berfokus pada meningkatkan pengalaman pelanggan dengan solusi cerdas yang dirancang untuk membuat interaksi lebih cepat, efisien, dan terasa alami.
        <br/><br/>
        Kami memiliki misi untuk membantu bisnis mengoptimalkan sistem mereka dengan teknologi modern yang mudah diintegrasikan. Dengan pendekatan ini, kami dapat mempersingkat waktu respons, meningkatkan kepuasan pelanggan, dan menyediakan layanan sepanjang waktu yang tetap ramah dan relevan.
        <br/><br/>
        <b><h2>Chatbot Layanan Pelanggan</h2></b>
        <br/>
        Kami menghadirkan chatbot layanan pelanggan yang dirancang untuk menjawab pertanyaan pelanggan dengan cepat dan tepat. Didukung oleh teknologi terkini, chatbot ini membantu bisnis meningkatkan efisiensi operasional, mempererat hubungan dengan pelanggan, dan menciptakan pengalaman yang membuat pelanggan kembali lagi.
      `,
    child: [
      {
        img: AiSolutionEcommerceChild1,
        content:
          'Chatbot siap melayani pelanggan kapan saja, menjawab ribuan pertanyaan secara bersamaan, dan secara signifikan mengurangi waktu tunggu.',
      },
      {
        img: AiSolutionEcommerceChild2,
        content:
          'Dengan teknologi NLP, chatbot mampu memahami konteks dan maksud di balik pertanyaan pelanggan, memberikan jawaban akurat untuk berbagai kebutuhan, mulai dari ketersediaan produk hingga pelacakan pesanan.',
      },
      {
        img: AiSolutionEcommerceChild3,
        content:
          'Dalam situasi yang lebih rumit atau membutuhkan penanganan khusus, chatbot meneruskan pertanyaan ke agen manusia lengkap dengan konteksnya, sehingga masalah dapat diselesaikan lebih cepat dan efisien.',
      },
    ],
    benefit: {
      title: 'Manfaat Penggunaan AI untuk E-Commerce',
      child: [
        {
          title: 'Meningkatkan Conversion Rates',
          description:
            'Dengan memberikan rekomendasi produk yang personal dan penetapan harga yang dinamis, AI membantu perusahaan e-commerce mengubah pengunjung menjadi pelanggan dengan lebih efektif.',
        },
        {
          title: 'Meningkatkan Pengalaman Pengguna',
          description:
            'Chatbot cerdas, rekomendasi personal, dan pencarian visual berbasis AI menciptakan pengalaman belanja yang lebih mudah dan menyenangkan bagi pelanggan.',
        },
        {
          title: 'Efisiensi Operasional yang Lebih Baik',
          description:
            'AI mengoptimalkan rantai pasokan dan pengelolaan inventaris, sehingga menekan biaya dan meningkatkan efisiensi dalam operasional e-commerce.',
        },
      ],
    },
    outro:
      'Dengan solusi AI kami, bisnis Anda dapat meraih kesuksesan luar biasa dan kepuasan pelanggan yang optimal.',
  },
  {
    title: 'Layanan Kesehatan',
    link: 'Health_Care',
    desc: 'Kami siap membantu bisnis Anda menghadapi tantangan era digital. Melalui layanan konsultasi, kami merancang strategi yang tepat, mengidentifikasi peluang terbaik, dan menyusun langkah-langkah konkret yang sejalan dengan tujuan bisnis Anda, sekaligus memastikan kepatuhan pada standar industri.',
    image: Health_Care,
    banner: AiSolutionHealtcare,
    description: `Penagihan yang akurat dan estimasi biaya yang tepat sangat penting dalam industri kesehatan untuk memastikan transparansi bagi pasien serta meningkatkan efisiensi operasional rumah sakit. Di CODR, kami telah mengembangkan solusi berbasis AI yang dirancang untuk mengotomatisasi estimasi tagihan medis, memberikan kejelasan dan ketepatan bagi semua pihak yang terlibat.
      <br/><br/>
      Dengan memanfaatkan data pasien, riwayat tagihan, dan catatan rumah sakit, sistem inovatif kami memberikan prediksi biaya dan evaluasi keuangan secara real-time. Hal ini membantu pasien dan penyedia layanan kesehatan membuat keputusan keuangan yang lebih tepat, sekaligus mendukung perencanaan keuangan yang lebih baik.
      <br/><br/>
      <b><h2>Sistem Estimasi Tagihan Berbasis AI</h2>
      </b><br/>
      Untuk mengatasi tantangan ini, kami menciptakan sistem estimasi tagihan berbasis AI yang canggih dan dapat terintegrasi dengan mulus ke dalam database rumah sakit serta sistem penagihan yang sudah ada. Dengan memanfaatkan model pembelajaran mesin yang canggih dan analitik data, solusi kami memperkirakan biaya berdasarkan berbagai faktor, seperti kondisi pasien, riwayat perawatan sebelumnya, dan data rumah sakit terkini.`,
    child: [
      {
        img: AiSolutionHealtcareChild1,
        content:
          'AI menganalisis kondisi pasien, perawatan yang diresepkan, dan cakupan asuransi untuk menghasilkan estimasi biaya yang disesuaikan secara real-time.',
      },
      {
        img: AiSolutionHealtcareChild2,
        content:
          'Dengan mempelajari riwayat tagihan dan data pasien, AI memberikan wawasan tentang pola penagihan umum dan langkah-langkah penghematan biaya yang potensial bagi rumah sakit.',
      },
      {
        img: AiSolutionHealtcareChild3,
        content:
          'Sistem ini memanfaatkan data historis untuk memprediksi tren penagihan di masa depan, membantu rumah sakit mengoptimalkan model harga mereka dan meningkatkan perencanaan keuangan.',
      },
    ],
    benefit: {
      title: 'Manfaat Penggunaan AI untuk Healthcare',
      child: [
        {
          title: 'Pengambilan Keputusan Lebih Cepat',
          description:
            'Dengan AI, pengambilan keputusan menjadi lebih cepat dan akurat, mendukung efisiensi di berbagai sektor.',
        },
        {
          title: 'Pengalaman Pasien yang Lebih Baik',
          description:
            'Alat berbasis AI seperti chatbot, asisten kesehatan virtual, dan pemantauan jarak jauh menyediakan dukungan 24/7, meningkatkan kepuasan dan keterlibatan pasien.',
        },
        {
          title: 'Pengurangan Biaya',
          description:
            'Dengan mengotomatisasi tugas rutin dan mengurangi kesalahan diagnosis, AI membantu menekan biaya layanan kesehatan secara keseluruhan.',
        },
        {
          title: 'Peningkatan Akurasi',
          description:
            'AI mengurangi risiko kesalahan manusia dalam diagnosis dan perawatan, memberikan hasil yang lebih baik bagi pasien dan meningkatkan kepercayaan terhadap layanan kesehatan.',
        },
      ],
    },
    outro:
      'Dengan solusi AI kami, bisnis Anda dapat meraih kesuksesan luar biasa dan kepuasan pelanggan yang optimal.',
  },
  {
    title: 'Automotive',
    link: 'Automotive_Auction',
    desc: 'Kami siap membantu bisnis Anda menghadapi tantangan era digital. Melalui layanan konsultasi, kami merancang strategi yang tepat, mengidentifikasi peluang terbaik, dan menyusun langkah-langkah konkret yang sejalan dengan tujuan bisnis Anda, sekaligus memastikan kepatuhan pada standar industri.',
    image: Automotive_Auction,
    banner: AiSolutionAuction,
    description: `
        Industri lelang otomotif sangat bergantung pada informasi yang tepat waktu dan akurat, baik untuk penjual maupun pembeli. Untuk mempermudah interaksi pelanggan dan memberikan dukungan yang lancar, kami telah mengembangkan chatbot berbasis AI yang dirancang khusus untuk platform lelang otomotif.
        <br/><br/>
        Sistem cerdas ini memungkinkan pengguna mendapatkan jawaban instan atas pertanyaan mereka mengenai detail kendaraan, prosedur lelang, promosi, dan lainnya—semua secara real-time. Dengan meningkatkan aksesibilitas informasi, kami menciptakan pengalaman pelanggan yang lebih mudah dan efisien.
        <br/><br/>
        <b><h2>Chatbot Berbasis AI untuk Lelang Otomotif</h2></b>
        <br/>
        Chatbot berbasis AI kami terintegrasi dengan mulus ke dalam aplikasi lelang, mengelola pertanyaan pelanggan dengan cepat dan akurat. Solusi inovatif ini tidak hanya mengurangi beban kerja tim layanan pelanggan, tetapi juga meningkatkan kepuasan pengguna dengan memberikan respons yang cepat dan dapat diandalkan.
      `,
    child: [
      {
        img: AiSolutionAuctionChild1,
        content:
          'Chatbot ini memberikan informasi lengkap tentang kendaraan, termasuk spesifikasi, riwayat, dan status penawaran, sehingga membantu pengguna membuat keputusan yang tepat.',
      },
      {
        img: AiSolutionAuctionChild2,
        content:
          'Sistem AI bekerja tanpa henti, memungkinkan pengguna mengakses dukungan kapan saja, bahkan di luar jam operasional.',
      },
      {
        img: AiSolutionAuctionChild3,
        content:
          'Untuk pertanyaan yang lebih kompleks, chatbot meneruskan percakapan ke agen manusia dengan menyertakan konteks penuh, memastikan proses transisi berjalan lancar.',
      },
    ],
    benefit: {
      title: 'Manfaat Penggunaan AI untuk Lelang Otomotif',
      child: [
        {
          title:
            'Engagement Pelanggan Proaktif dengan Analitik Prediktif Berbasis AI',
          description:
            'Platform lelang dapat memprediksi permintaan kendaraan dan hasil lelang di masa depan, membantu penjual menentukan waktu terbaik untuk memasang daftar kendaraan mereka. Pembeli juga akan menerima pemberitahuan ketika kendaraan yang sesuai dengan preferensi mereka kemungkinan akan tersedia, meningkatkan keterlibatan dan retensi pelanggan.',
        },
        {
          title: 'Meningkatkan Kepercayaan Pembeli dengan Rekomendasi Personal',
          description:
            'AI menganalisis preferensi pembeli, riwayat penawaran sebelumnya, dan perilaku mereka untuk memberikan rekomendasi kendaraan yang relevan. Pendekatan personal ini mempercepat proses pencarian, menjadikannya lebih tepat sasaran, serta meningkatkan kepercayaan dan kepuasan pembeli.',
        },
        {
          title: 'Transaksi Penjualan Tanpa Hambatan Melalui Otomasi AI',
          description:
            'AI mengotomatisasi proses penjualan utama, seperti verifikasi penawar, konfirmasi pembayaran, dan dokumen pasca-lelang. Otomasi ini menghilangkan penundaan dan memastikan alur transaksi yang lancar untuk pembeli maupun penjual.',
        },
        {
          title: 'Dukungan Pelanggan yang Lebih Baik dengan Chatbot AI',
          description:
            'Chatbot dan asisten virtual berbasis AI menyediakan dukungan pelanggan 24/7 untuk pembeli dan penjual, menjawab pertanyaan seputar kendaraan, proses lelang, dan pembaruan status penawaran. Layanan real-time ini mengurangi ketergantungan pada manusia, meningkatkan kepuasan pelanggan, dan mengurangi waktu tunggu.',
        },
      ],
    },
    outro:
      'Dengan solusi AI kami, bisnis Anda dapat meraih kesuksesan luar biasa dan kepuasan pelanggan yang optimal.',
  },
];

const someProject = [
  {
    id: 'WA-1',
    title: 'Toyota Trust E-Commerce',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. At in sed in
          libero dictumst. Quis leo nascetur gravida leo.`,
    details: {
      overview:
        'Toyota TRUST adalah layanan resmi Toyota yang menjual mobil bekas Toyota berkualitas dan bersertifikasi sehingga pelanggan dapat menikmati garansi resmi dari PT Toyota Astra Motor. Setiap mobil bekas Toyota sudah melalui proses pengecekan di 203 titik, sehingga dapat dipastikan aman dan transparan.',
      approach:
        'Sistem Toyota TRUST berbasiskan Web Application yang terintergasi dengan aplikasi inspeksi, aplikasi sales, dan aplikasi Enterprise Resource Planning (ERP).Teknologi yang digunakan adalah: HTML, CSS, JavaScript, react.Js, Node.Js, Express.Js, React. Native',
      result:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
      cardImage: '/tt/tt1.png',
    },
  },
  {
    id: 'WA-4',
    title: 'Hybid Lelang (hybid.id)',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. At in sed in
          libero dictumst. Quis leo nascetur gravida leo.`,
    details: {
      overview:
        'HYBID merupakan produk dari PT. Balai Lelang Anugerah adalah balai lelang yang menyediakan jasa lelang terbuka dengan pengelolaan yang professional, transparan dan terpercaya. Proses lelang dapat dilakukan secara hybrid, dimana customer dapat melakukan Bid melalui website ataupun datang ke lokasi lelang. Platform lelang yang dibangun meliputi. Website lelang customer, website untuk konduktor lelang, dan admin panel untuk mengelola operasional internal perusahaan.',
      approach:
        'Platform lelang yang dibangun meliputi. Website lelang customer, website untuk konduktor lelang, dan admin panel untuk mengelola operasional internal perusahaan. Pada aplikasi lelang ini sistem menggunakan websocket untuk mengakomodir kebutuhan event lelang secara real-time. \nTech Stack: HTML, CSS, JavaScript, React.Js, PHP, Laravel, Websocket, Xendit integrated',
      result:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
      cardImage: '/hybid/hybid1.png',
    },
  },
  {
    id: 'MA-2',
    title: 'Rumah Siap Kerja',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. At in sed in
          libero dictumst. Quis leo nascetur gravida leo.`,
    details: {
      overview:
        'Rumah Siap Kerja merupakan Platform pendidikan untuk pengembangan skills professional dan wirausaha baik secara soft skill maupun hardskills. yang menyediakan sertifikat resmi untuk setiap peserta yang mengikuti sesi pelatihan dari Rumah Siap Kerja. Aplikasi ini menyediakan daftar pelatihan dengan kategori bidang pelatihan, informasi detail materi, rincial silabus, dan fitur pembayaran online untuk pembelian materi',
      approach:
        'Aplikasi Rumah Siap Kerja dibangun menggunakan framework react native (cross-platform framework) agar aplikasi dapat diakses oleh pengguna Andorid dan IOS sekaligus. User dapat mengakses aplikasi Rumah Siap Kerja melalui: \nGoogle play: https://play.google.com/store/apps/details?id=com.rumahsiapkerja',
      result:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
      cardImage: '/rsk/rsk1.png',
    },
  },
  {
    id: 'MA-1',
    title: 'Digital Appraisal',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. At in sed in
          libero dictumst. Quis leo nascetur gravida leo.`,
    details: {
      overview:
        'Digital Appraisal adalah aplikasi mobile untuk mengakomodir proses inspeksi kendaraan untuk memberikan penilaian terhadap kualitas kendaraan yang akan diperjualbelikan. Pada aplikasi ini, setiap kendaraan yang sudah selesai di inspeksi, akan diberikan skor sebagai acuan untuk pemberian rekomendasi harga kendaraan.',
      approach:
        'Sistem dibangun dengan framework React Native (cross-platform framework) agar dapat diakses oleh pengguna Android dan IOS. Sistem ini terintegrasi dengan sistem aplikasi sales dan Enterprise Resource Planning (ERP).\nTech Stack: HTML, CSS, JavaScript, React.Js, Node.Js, Express.Js, React. Native',
      result:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit non aliquam, aliquam lorem. Suspendisse dui nunc sem aliquet pulvinar arcu. Blandit viverra sollicitudin feugiat libero semper quisque arcu. Ac pretium diam nisi ut eu vel felis fringilla sed. Ac praesent vel, amet, odio porttitor. Nec egestas fermentum ultricies tempor consectetur odio pellentesque. Tristique ultrices hendrerit mauris nibh orci in neque risus dictum. Leo, fames leo fusce a diam. Nibh auctor elit tellus nibh.',
      cardImage: '/digital/digital1.png',
    },
  },
];

export {
  clients,
  FAQList,
  projectCategory,
  someProject,
  ourValues,
  whyCODRdata,
  ourSolutionsData,
  dataTestimoni,
  dataPortfolio,
};
